import { axiosInstanceV2 } from "./AxiosInstance"

const API_URL = "/operationstomodules"

export const getOperationsToModules = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching operations to modules", error)
    throw error
  }
}
export const createOperationToModule = async (operationToModuleData) => {
    try {
        const response = await axiosInstanceV2.post(API_URL, operationToModuleData)
        return response.data
    } catch (error) {
        console.error("Error creating operation to module", {
        error: error.response?.data,
        requestData: operationToModuleData,
        })
        throw error
    }
    }   
export const updateOperationToModule = async (operationToModuleId, operationToModuleData) => {
    try {
        const response = await axiosInstanceV2.put(`${API_URL}/${operationToModuleId}`, operationToModuleData)
        return response.data
    } catch (error) {
        console.error("Error updating operation to module", error)
        throw error
    }
}
export const deleteOperationToModule = async (operationToModuleId) => {
    try {
        const response = await axiosInstanceV2.delete(`${API_URL}/${operationToModuleId}`)
        return response.data
    } catch (error) {
        console.error("Error deleting operation to module", error)
        throw error
    }
}
export const getOperationToModuleById = async (operationToModuleId) => {
    try {
        const response = await axiosInstanceV2.get(`${API_URL}/${operationToModuleId}`)
        return {
            data: response.data.data,
            status: response.status,
            message: response.data.message,
        }
    } catch (error) {
        console.error("Error fetching operation to module by ID", error)
        throw error
    }
}
